<template>
  <transition v-if="noTransition" enter-active-class="animate__animated animate__fadeIn" appear>
    <div class="tw:absolute tw:w-full" style="z-index: -1" :class="{'tw:sicura-solution-bg-home-gradient tw:h-full': isSicuraSolution || sicuraSolution, 'tw:bg-home-gradient tw:h-3/4': !isSicuraSolution && !sicuraSolution}" />
  </transition>
  <div v-else class="tw:absolute tw:w-full" style="z-index: -1" :class="{'tw:sicura-solution-bg-home-gradient tw:h-full': isSicuraSolution || sicuraSolution, 'tw:bg-home-gradient tw:h-3/4': !isSicuraSolution && !sicuraSolution}" />

  <div
    id="public-layout"
    v-bind="{ ...$attrs }"
    :class="`
      tw:w-screen
      tw:h-screen
      tw:flex
      tw:p-6
      ${justify === 'center' ? 'tw:justify-center' : justify === 'end' ? 'tw:justify-end' : 'tw:justify-start'}
      ${align === 'center' ? 'tw:items-center' : align === 'end' ? 'tw:items-end' : 'tw:items-start'}`"
  >
    <transition v-if="!noTransition" enter-active-class="animate__animated animate__fadeIn" appear>
      <slot />
    </transition>
    <div v-else>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { useBrand } from '@/composables/useBrand';
import { defineComponent } from 'vue';

export default defineComponent({

  props: {
    cover: {
      type: Boolean,
      default: false,
      required: false,
    },
    align: {
      type: String,
      default: 'center',
    },

    justify: {
      type: String,
      default: 'start',
    },
    noFooter: {
      type: Boolean,
      default: false,
    },
    noTransition: {
      type: Boolean,
      default: false,
    },
    sicuraSolution: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  setup() {
    const { isSicuraSolution } = useBrand();
    return { isSicuraSolution };
  },
});
</script>
<style scoped></style>
